const calculateResponses = (tooltipItems) => {
  let sum = 0;

  tooltipItems.forEach(function(tooltipItem) {
    sum += tooltipItem.parsed.y;
  });
  return 'Responses:  ' + sum;
};

export const chartAreaBorder = {
  id: 'chartAreaBorder',
  beforeDraw(chart, args, options) {
    const { ctx, chartArea: { left, top, width, height } } = chart;
    ctx.save();
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.setLineDash(options.borderDash || []);
    ctx.lineDashOffset = options.borderDashOffset;
    ctx.strokeRect(left, top, width, height);
    ctx.restore();
  },
};
export const plugins = [chartAreaBorder];
export const options = {
  datasets: {
    bar: {
      maxBarThickness: 27,
      borderRadius: 4,
      pointStyle: 'rect',
    },
  },

  onHover: function(e) {
    const points = this.getElementsAtEventForMode(
      e,
      'index', { axis: 'x', intersect: true },
      false,
    );

    if (points.length) e.native.target.style.cursor = 'pointer';
    else e.native.target.style.cursor = 'default';
  },
  responsive: true,
  maintainAspectRatio: false,
  // aspectRatio: 2,
  interaction: {
    intersect: false,
    mode: 'index',
  },
  plugins: {
    title: {
      display: false,
    },
    legend: {
      display: false,
    },
    tooltip: {
      yAlign: 'bottom',
      xAlign: 'center',
      backgroundColor: '#191236',
      usePointStyle: true,
      callbacks: {
        title: () =>{},
        footer: calculateResponses,
        label: (context) => {
          return  context.dataset.label + ':' + '  ' + context.parsed.y;
        },
      },
      bodySpacing: 8,
      bodyFont: {
        family: 'Open Sans',
        weight: 700,
      },
      footerMarginTop: 8,
      footerFont:{
        family: 'Open Sans'
      },
      titleAlign: 'center',
      boxPadding: 8,
      padding: 8,
      displayColors: true,
      position: 'nearest',
    },
    datalabels: {
      display: function(context) {
        if (context.active) {
          return false;
        }
        return context.dataset.data[context.dataIndex] !== 0;
      },
      color: '#191236',
      labels: {
        title: {
          font: {
            weight: 600,
          },
        },
      },
    },
    chartAreaBorder: {
      borderColor: '#E8E8ED',
      borderWidth: 1,
    },
  },
  scales: {
    x: {
      stacked: true,
      ticks: {
        color: '#191236',
        font: {
          family: 'Open Sans',
          size: 14,
          weight: 400,
          lineHeight: 1.5,
        },
      },
      grid: {
        display: false,
        color: '#E8E8ED',
        borderColor: '#E8E8ED',
      },
    },
    y: {
      grid: {
        color: '#E8E8ED',
        borderColor: '#E8E8ED',
      },
      stacked: true,
      beginAtZero: true,
      min: 0,
      ticks: {
        stepSize: 20,
        color: '#5E5972',
        major: {
          enabled: true,
        },
        font: {
          family: 'Open Sans',
          size: 14,
          weight: 400,
          lineHeight: 1.5,
        },
      },
    },
  },
};
